import { carouselStyles } from "@insite/content-library/Components/ProductCompareCarousel";
import { ProductCompareCarouselStyles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import { clearBtnStyle, removeBtnFocusBorder } from "@waytek/Utilities/styleguide/btnIcon";
import { colorPalette, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

ProductCompareCarouselStyles.navigationLink = {
    ...ProductCompareCarouselStyles.navigationLink,

    css: css`
        position: relative;
        left: -5px;
    `,
};

ProductCompareCarouselStyles.headerText = {
    ...ProductCompareCarouselStyles.headerText,

    variant: "h1",
};

ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    ...ProductCompareCarouselStyles.removeProductFromCompareClickable,

    css: css`
        ${ProductCompareCarouselStyles.removeProductFromCompareClickable?.css}
        ${clearBtnStyle}

        right: 11px;
    `,
};

ProductCompareCarouselStyles.carousel = {
    ...ProductCompareCarouselStyles.carousel,

    carouselSlideInner: {
        css: css`
            ${carouselStyles.carouselSlideInner?.css}

            padding: 0 10px;
        `,
    },

    attributeLabelsCellGridItem: {
        css: css`
            ${carouselStyles.attributeLabelsCellGridItem?.css}

            &&& {
                margin-top: 16px;
                border-top: solid 2px ${colorPalette.common.global.industrialTaupe};
            }

            ${mediaQueriesBP.maxMD} {
                border: solid 1px ${colorPalette.common.global.dataTableRowDivider};
                border-right: 0;
                border-bottom: 0;
            }
        `,
    },

    attributeValuesCellGridItem: {
        css: css`
            ${carouselStyles.attributeValuesCellGridItem?.css}

            &&& {
                overflow: hidden;
                margin-top: 16px;
                border-top: solid 2px ${colorPalette.common.global.industrialTaupe};
            }

            ${mediaQueriesBP.maxMD} {
                border: solid 1px ${colorPalette.common.global.dataTableRowDivider};
                border-left: 0;
                border-bottom: 0;
            }
        `,
    },

    prevArrowButton: {
        css: css`
            ${carouselStyles.prevArrowButton?.css}

            ${clearBtnStyle}
            ${removeBtnFocusBorder}

            left: -5px;
        `,
    },

    nextArrowButton: {
        css: css`
            ${carouselStyles.nextArrowButton?.css}

            ${clearBtnStyle}
            ${removeBtnFocusBorder}

            right: -5px;
        `,
    },

    attributeLabelsGridContainer: {
        css: css`
            ${carouselStyles.attributeLabelsGridContainer?.css}

            box-shadow: none;
            border-right: solid 1px ${colorPalette.common.global.industrialTaupe};
        `,
    },

    attributeLabelGridItem: {
        css: css`
            ${carouselStyles.attributeLabelGridItem?.css}

            border: 0;
            border-right: 0;
            padding: 0 20px;
            min-height: 42px;
            justify-content: flex-start;
            align-items: center;

            &:nth-child(even) {
                background-color: ${colorPalette.common.global.dataTableRowEvenBg};
            }

            ${mediaQueriesBP.maxMD} {
                border-bottom: solid 1px ${colorPalette.common.global.dataTableRowDivider};
            }

            ${mediaQueriesBP.minMD} {
                min-height: 60px;
            }
        `,
    },

    attributeLabelText: {
        size: 14,
        weight: "normal",
        lineHeight: 1.71,
        color: colorPalette.common.global.dataTableRowColor,
    },

    attributeValuesGridContainer: {
        gap: 0,
    },

    attributeValueGridItem: {
        css: css`
            ${carouselStyles.attributeValueGridItem?.css}

            padding: 0;
            padding-left: 25px;
            padding-right: 25px;
            border: 0;
            border-right: 0;
            min-height: 42px;
            justify-content: flex-start;
            align-items: center;

            &:nth-child(even) {
                background-color: ${colorPalette.common.global.dataTableRowEvenBg};
            }

            ${mediaQueriesBP.maxMD} {
                border-bottom: solid 1px ${colorPalette.common.global.dataTableRowDivider};
            }

            ${mediaQueriesBP.minMD} {
                min-height: 60px;
            }
        `,
    },

    attributeValueText: {
        size: 14,
        weight: "normal",
        lineHeight: 1.71,
        color: colorPalette.common.global.dataTableRowColor,
    },
};
